/** @format */

import React from "react";
import { Field, ErrorMessage } from "formik";
import Error from "./FormError";

const Input = ({ label, name, required, type, ...rest }) => {
  const star = ["*"];

  return (
    <div className="form__control">
      <label htmlFor={name}>
        {label} <span className="label__required"> {required && star[0]} </span>
      </label>
      <Field name={name} type={type} {...rest} autoComplete="username" />
      <ErrorMessage name={name} component={Error} />
    </div>
  );
};

export default Input;
